import { defineMessages } from 'react-intl';

export default defineMessages({
    verbalAuthorization: {
        id: 'ml.gateway.endorsement.common.verbalAuthorization.Verbal Authorization',
        defaultMessage: 'Verbal Authorization'
    },
    formsEligible: {
        id: 'ml.gateway.endorsement.common.verbalAuthorization.formsEligible',
        defaultMessage: 'The following forms are eligible for verbal authorization.'
    },
    agentScript: {
        id: 'ml.gateway.endorsement.common.verbalAuthorization.Agent Script',
        defaultMessage: 'Agent Script'
    },
    verballyAuthorized: {
        id: 'ml.gateway.endorsement.common.verbalAuthorization.Verbally authorized',
        defaultMessage: 'Verbally authorized'
    },
    et: {
        id: 'ml.gateway.endorsement.common.verbalAuthorization.ET',
        defaultMessage: 'ET'
    },
    iAccept: {
        id: 'ml.gateway.endorsement.common.verbalAuthorization.I accept',
        defaultMessage: 'I accept'
    },
    ut: {
        id: 'ml.gateway.endorsement.common.verbalAuthorization.UT',
        defaultMessage: 'UT'
    },
})